export interface SectionInfo {
  id: string;
  header: string;
  summary: string;
  link?: string;
  settings: { name: string; description: string; link?: string }[];
}

export default class ConfigurationSettingsSectionInfo {
  static readonly links = {
    documentSettings: {
      link: 'https://semantria-docs.lexalytics.com/docs/configuration-values',
    },
    entities: {
      link: 'https://semantria-docs.lexalytics.com/docs/entity-recognition',
    },
    responseType: {
      settings: {
        'auto-response': {
          link: 'https://semantria-docs.lexalytics.com/docs/auto-response',
        },
        callback: {
          link: 'https://semantria-docs.lexalytics.com/docs/callback',
        },
        polling: {
          link: 'https://semantria-docs.lexalytics.com/docs/pulling',
        },
      },
    },
    sentiment: {
      link: 'https://semantria-docs.lexalytics.com/docs/sentiment-bearing-phrases',
    },
    themes: {
      link: 'https://semantria-docs.lexalytics.com/docs/themes',
    },
    topics: {
      settings: {
        'concept-topics': {
          link: 'https://semantria-docs.lexalytics.com/docs/user-categories-concept-topics',
        },
        'enable-auto-categories': {
          link: 'https://semantria-docs.lexalytics.com/docs/user-categories-concept-topics',
        },
        'enable-query-topics': {
          link: 'https://semantria-docs.lexalytics.com/docs/queries-query-topics',
        },
        'return-taxonomy': {
          link: 'https://semantria-docs.lexalytics.com/docs/taxonomy',
        },
        'stem-query-topics': {
          link: 'https://semantria-docs.lexalytics.com/docs/queries-query-topics',
        },
        'use-machine-learning': {
          link: 'https://semantria-docs.lexalytics.com/docs/categorization#machine-learning',
        },
      },
    },
  };
}
